import Ajv, { ErrorObject } from 'ajv'
import ajvErrors from 'ajv-errors'
import addFormats from 'ajv-formats'

import * as React from 'react'

const ajv = new Ajv({ allErrors: true, validateSchema: true, $data: true })
ajvErrors(ajv)
addFormats(ajv)

const ValidationContext = React.createContext(null)

export const ValidationProvider = ({ children, schema }) => {
  const validate = ajv.compile(schema)

  const [errors, setErrors] = React.useState<
    ErrorObject<string, Record<string, string>, unknown>[]
  >()

  const getError = React.useCallback(
    instancePath => {
      if (!errors || !errors.length || !instancePath) {
        return null
      }
      const error = errors.find(
        error =>
          error.instancePath.slice(1) === instancePath.replace(/\./g, '/')
      )
      return error ? error.message : null
    },
    [errors]
  )

  const validateData = React.useCallback(
    formData => {
      const valid = validate(formData)
      if (valid) {
        setErrors([])
      } else {
        setErrors(validate.errors)
      }

      return valid
    },
    [validate]
  )

  return (
    <ValidationContext.Provider value={{ validateData, getError }}>
      {children}
    </ValidationContext.Provider>
  )
}

export const useValidation = () => {
  const context = React.useContext(ValidationContext)
  if (!context) {
    console.error(
      'useValidation must be called from within a ValidationProvider'
    )
  }
  return context
}
